<template>
  <div>
    <v-btn
      color="sz_violet"
      class="mb-3"
      :disabled="!isCurrentEdition"
      @click="openModal"
    >
      {{ $t('buttons.edit') }}
    </v-btn>
    <AppModal
      :visible="modalVisibility"
      @close="closeModal"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark text-xs-left">
          {{ $t('family_card.edit_note.title') }}
        </h2>
      </template>
      <template slot="content">
        <v-textarea
          v-model="note"
          v-validate="validationRules.get('long_regular_field')"
          name="input-7-1"
          auto-grow
          :placeholder="$t('family_card.edit_note.placeholder')"
          :error-messages="errors.collect('regular_field')"
          data-vv-name="regular_field"
        />
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="mt-2"
          wrap
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex
            shrink
            order-xs2
            order-sm1
            :mt-3="$vuetify.breakpoint.xsOnly"
            :mr-3="$vuetify.breakpoint.smAndUp"
          >
            <a @click="cancel">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :loading="loader"
              :disabled="loader"
              @click="send"
            >
              {{ $t('buttons.send') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
  </div>
</template>

<script>
import statusesId from '@/constants/statusesId';
import validationRules from '@/constants/validationRules';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'EditDescription',
    components: { AppModal },
    props: {
        noteValue: {
            type: String
        },
        familyId: {
            required: true,
            type: [Number, String]
        }
    },
    data: () => ({
        statusesId,
        validationRules,
        modalVisibility: false,
        note: null,
        loader: false
    }),
    computed: {
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    },
    watch: {
        noteValue: {
            handler (val) {
                if (val) {
                    this.note = val;
                }
            },
            immediate: true
        }
    },
    methods: {
        openModal () {
            this.modalVisibility = true;
        },
        closeModal () {
            this.modalVisibility = false;
        },
        cancel () {
            this.closeModal();
        },
        send () {
            this.loader = true;
            this.$store
                .dispatch('family/editFamilyDescription', {
                    familyEditionId: this.familyId,
                    data: this.note
                })
                .then(() => {
                    this.closeModal();
                })
                .finally(() => {
                    this.loader = false;
                });
        }
    }
};
</script>

<style scoped></style>
